import { CircularProgress } from "@chakra-ui/react";
import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import AboutPage from "../Pages/About";
import AddEditForm from "../Pages/AddEdit";
import BlogAdd from "../Pages/BlogAdd";
import BlogPage from "../Pages/BlogPage";
import ContactPage from "../Pages/Contact";
import Login from "../Pages/Login";
import MainBlogPage from "../Pages/MainBlogPage";
import PrivateRoutes from "./PrivateRoutes";
import {
  ABOUT,
  ADD,
  BLOG,
  BLOGADD,
  CONTACT,
  EMI,
  HOME,
  LISTING,
  LOGIN,
  MAINBLOG,
  SEARCH,
} from "./routes";

const Home = lazy(() => import("../Pages/Home"));
const Search = lazy(() => import("../Pages/Search"));
const DetailsPage = lazy(() => import("../Pages/Datails"));
const EMIcalc = lazy(() => import("../Pages/EMIcalc"));

const AllRoutes = () => {
  return (
    <Suspense
      fallback={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress isIndeterminate color="#f75d34" />
        </div>
      }
    >
      <Routes>
        <Route path={HOME} element={<Home />} />
        <Route path={SEARCH} element={<Search />} />
        <Route path={LISTING} element={<DetailsPage />} />
        <Route path={EMI} element={<EMIcalc />} />
        <Route path={BLOG} element={<BlogPage />} />
        <Route path={MAINBLOG} element={<MainBlogPage />} />
        <Route path={CONTACT} element={<ContactPage />} />
        <Route path={ABOUT} element={<AboutPage />} />
        <Route path={LOGIN} element={<Login />} />
        <Route element={<PrivateRoutes />}>
          <Route path={ADD} element={<AddEditForm />} />
          <Route path={BLOGADD} element={<BlogAdd />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AllRoutes;
